module.exports = __webpack_public_path__ + "static/banner-search-marketing-8c5916a60012cdc82d3ddcff431bf085.png";